// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Field__Component[data-v-c12bcb22] {\n  direction: ltr;\n  text-align: right;\n}\n.Field__Component.right[data-v-c12bcb22] {\n    text-align: right;\n}\n.Field__Component.left[data-v-c12bcb22] {\n    text-align: left;\n}\n.Field__Component.center[data-v-c12bcb22] {\n    text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
